/**
 * @format
 * @flow
 */
import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { MdLocationOn } from 'react-icons/md';
import DateJp from 'UltraDate.js';
import {
  getTaskDetail,
  getCategories,
  getLicensesInTask,
  registerTask,
  resetRegisterTask
} from '../../../actions/Task';
import { getTemplateData } from '../../../actions/Template';
import Template from '../../../components/Template/AfterLoginTemplate';
import generateCalendarHash from '../../../lib/generate_calendar_hash';
import Modal from '../../../components/Common/Modal';
import TaskCardForDetail from '../../../components/Parts/TaskCardForDetail';
import * as RT from '../../../constants/Routing';
import { addressFromPostalCode, validRange } from '../../../lib/function';
import nurse from '../../../assets/images/nurse.jpg';
import caregiver from '../../../assets/images/caregiver.jpg';
import childcare from '../../../assets/images/childcare.jpg';
import cleaning from '../../../assets/images/cleaning.jpg';
import accounting from '../../../assets/images/accounting.jpg';
import pickup from '../../../assets/images/pickup.jpg';
import recreation from '../../../assets/images/recreation.jpg';
import rehabilitation from '../../../assets/images/rehabilation.jpg';
import reception from '../../../assets/images/reception.jpg';
import cook from '../../../assets/images/cook.jpg';
import serving from '../../../assets/images/serving.jpg';
import education from '../../../assets/images/education.jpg';
import image2base64 from 'image-to-base64';
import { RadioGroup, RadioButton } from 'react-radio-buttons';
import Tooltip from 'react-simple-tooltip';

DateJp.setDefaultLocale('ja');

function generateWeekDay(weekDays, selectWeekDays) {
  return weekDays.map(item => {
    return (
      <ul>
        <li>
          <input
            type="checkbox"
            class="form-control"
            id={item.dayOfTheWeek}
            name={item.dayOfTheWeek}
            value={item.dayOfTheWeek}
            checked={item.checked}
            onClick={e => {
              selectWeekDays(e);
            }}
          ></input>
          <label for={item.dayOfTheWeek}>{item.dayOfTheWeek}</label>
        </li>
      </ul>
    );
  });
}

class Component extends React.Component {
  constructor(props) {
    super(props);
    const year = new DateJp().addDate(2).getFullYear();
    const month = `0${new DateJp().addDate(2).getMonth() + 1}`.slice(-2);
    const date = `0${new DateJp().addDate(2).getDate()}`.slice(-2);
    // const hours = `0${(new DateJp()).getHours()}`.slice(-2)
    const minutes = '00';
    this.currentUser = JSON.parse(localStorage.getItem('current_user'));

    this.state = {
      modalOpen: false,
      preview: false,
      months: generateCalendarHash.generateMonths(),
      years: generateCalendarHash.generateYears(),
      days: generateCalendarHash.generateDays(),
      hours: generateCalendarHash.generateHours(),
      minutes: generateCalendarHash.generateMinutes(),
      start_year: year,
      start_month: month,
      start_date: date,
      start_hours: '09',
      start_minutes: minutes,
      end_year: year,
      end_month: month,
      end_date: date,
      end_hours: '12',
      end_minutes: minutes,
      taskCategoryName: '',
      reward: '',
      rewardText: '',
      description: '',
      title: '',
      titleValid: true,
      images: '',
      licenseFormSize: 1,
      licenseValid: true,
      canAddLicenseForm: false,
      licenseDuplicated: false,
      dateValid: true,
      allValid: false,
      base64Image: '',
      templateId: '',
      postCode: this.props.Task.taskDetail.task_postalCode || this.currentUser.postalCode,
      prefecture: this.props.Task.taskDetail.task_prefecture || this.currentUser.prefecture,
      city: this.props.Task.taskDetail.task_city || this.currentUser.municipality,
      block: this.props.Task.taskDetail.task_block || this.currentUser.locDescription,
      street: this.props.Task.taskDetail.task_street || this.currentUser.street,
      weekDays: generateCalendarHash.generateWeekItems(),
      isRegular: true /// true means regular and false means interval
    };
  }

  componentDidMount = () => {
    const { accessToken, enterpriseId } = this.currentUser;
    const taskId = this.props.match.params.task_id;
    console.log('TCL: Component -> componentWillMount -> taskId', this.currentUser);
    this.props.getCategories(accessToken);
    this.props.getLicensesInTask(accessToken);
    if (taskId) {
      this.props.getTaskDetail(enterpriseId, accessToken, taskId);
    }
    const body = {
      enterpriseId: this.currentUser.enterpriseId
    };
    this.props.getTemplateData(body, accessToken);
  };

  componentWillReceiveProps = next => {
    if (next.Task.taskDetailLoaded && !this.props.Task.taskDetailLoaded) {
      const task = next.Task.taskDetail;
      console.log('TCL: componentWillReceiveProps -> task', task.taskCategoryDetail[0].key);

      task.licenseDetail.forEach((element, index) => {
        this.state[`license${index + 1}`] = element.key;
      });
      this.setState({
        allValid: true,
        title: 'コピー -' + task.title,
        taskCategoryName: task.taskCategoryDetail[0].value,
        images: task.taskPhotoId,
        rewardText: task.fee,
        reward: Number(task.fee) / 100,
        description: task.description,
        licenseFormSize: task.licenseDetail.length === 0 ? 1 : task.licenseDetail.length,
        canAddLicenseForm: task.licenseDetail.length === 0 ? false : true
      });
    }
  };

  componentWillUnmount = () => {
    this.props.resetRegisterTask();
  };

  componentDidUpdate = () => {
    if (this.props.Task.createdTask === true && this.state.modalOpen === false) {
      this.setState({ modalOpen: true });
    }
  };

  previewClose = () => {
    this.setState({ preview: false }, () => {
      window.scrollTo(0, 0);
    });
  };

  registerPreview = () => {
    this.setState({ preview: true }, () => {
      window.scrollTo(0, 0);
    });
  };

  registerTaskAction = () => {
    const params = this.generateParams();
    console.log('TCL: registerTaskAction -> params', params);
    const token = this.currentUser.accessToken;
    // console.log('登録します', params, token)
    this.props.registerTask(params, token);
    // this.setState({ modalOpen: false });
  };

  _generateLicenseId = () => {
    const licenseId = [];

    for (let i = 0; i < this.state.licenseFormSize; i++) {
      licenseId.unshift(this.state[`license${i + 1}`]);
    }

    return licenseId;
  };

  _generateBase64 = () => {
    const image = this._checkForImageAvailability();
    image2base64(image) // you can also to use url
      .then(response => {
        this.setState({ base64Image: response });
      })
      .catch(error => {
        console.log(error);
      });
  };

  generateParams = () => {
    const startDate = `${this.state.start_year}/${this.state.start_month}/${this.state.start_date}`;
    const startTime = `${this.state.start_hours}:${this.state.start_minutes}`;
    const endDate = `${this.state.end_year}/${this.state.end_month}/${this.state.end_date}`;
    const endTime = `${this.state.end_hours}:${this.state.end_minutes}`;

    const licenseId = this._generateLicenseId();
    let licenseDetail = [];

    var finalWeekDays = [];
    if (!this.state.isRegular) {
      var length = this.state.weekDays.length;
      for (let index = 0; index < length; index++) {
        const element = this.state.weekDays[index];
        if (element.checked) {
          finalWeekDays.push(element.dayInt);
        }
      }
    }
    console.log('TCL: generateParams -> finalWeekDays', finalWeekDays);

    // if (!this.state.isRegular) {
    //   getWeekRangeDate(startDate, endDate, finalWeekDays);
    // }

    for (let index = 0; index < licenseId.length; index++) {
      const id = licenseId[index];

      const item = this.props.Task.licenses.filter(x => {
        // console.log('ふぃるたー', x, i, id)
        return Number(x.key) === Number(id);
      });

      if (item.length > 0) {
        licenseDetail = licenseDetail.concat(item);
      }
    }
    var taskCategory = '';
    if (this.props.Task.categories.length > 0 && !!this.state.taskCategoryName) {
      var taskCategory = this.props.Task.categories.find(
        cat => String(cat.categoryName) === String(this.state.taskCategoryName)
      );
    }
    const imgParam = this._checkForImageAvailability();
    const hasImage = this._checkIfUrl();
    console.log(this.state.base64Image);
    return {
      code: 'create',
      startDate,
      startTime,
      endDate,
      endTime,
      title: this.state.title,
      description: this.state.description,
      fee: this.state.rewardText,
      taskPhotoId: hasImage ? imgParam : 'data:image/png;base64,' + this.state.base64Image,
      licenseId,
      licenseDetail,
      taskCategoryId: taskCategory.categoryId || '',
      enterpriseId: this.currentUser.enterpriseId,
      task_prefecture: this.state.prefecture,
      task_city: this.state.city,
      task_block: this.state.block,
      task_street: this.state.street,
      task_postalCode: this.state.postCode,
      templateId: this.state.templateId,
      finalWeekDays
    };
  };

  generateTask = () => {
    let taskCategory = null;
    if (this.props.Task.categories.length > 0 && !!this.state.taskCategoryName) {
      taskCategory = this.props.Task.categories.find(
        cat => String(cat.categoryName) === String(this.state.taskCategoryName)
      );
      taskCategory = [
        {
          ...taskCategory,
          key: taskCategory.categoryId,
          value: taskCategory.categoryName
        }
      ];
    }

    const task = {
      applicantCount: 0,
      completedCount: 0,
      deactivatedCount: 0,
      enterprise: {},
      enterpriseId: '',
      participant: [],
      taskCategoryDetail: taskCategory,
      taskId: '',
      workingHours: ''
    };

    const newTask = { ...task, ...this.generateParams() };

    return newTask;
  };

  toTopPage = () => {
    this.props.history.push(RT.TASK_INDEX_PATH);
  };

  modalOpen = () => {
    this.setState({ modalOpen: true });
  };

  onImageSelected = e => {
    const file = e.target.files[0];
    const fr = new FileReader();

    fr.onload = () => {
      // eslint-disable-next-line react/no-string-refs
      const imgNode = this.refs.image;
      imgNode.src = fr.result;
      this.setState({ images: fr.result }, () => {
        this._checkAllEnter();
      });
    };
    if (file === undefined) {
      this.setState({ images: '' }, () => {
        this._checkAllEnter();
      });
    } else {
      fr.readAsDataURL(file);
    }
  };

  _checkAllEnter = () => {
    const { weekDays, isRegular } = this.state;
    let index = weekDays.findIndex(element => element.checked === true);
    var isInterval = isRegular ? true : index !== -1;
    console.log('TCL: _checkAllEnter -> isInterval', isRegular, isInterval, index);
    const licenseDuplicated = this._licenseDuplicatedCheck();
    const dateValid = this._dateValidation();
    if (
      !!this.state.start_year &&
      !!this.state.start_month &&
      !!this.state.start_date &&
      !!this.state.start_hours &&
      !!this.state.start_minutes &&
      !!this.state.end_year &&
      !!this.state.end_month &&
      !!this.state.end_date &&
      !!this.state.end_hours &&
      !!this.state.end_minutes &&
      !!this.state.taskCategoryName &&
      !!this.state.rewardText &&
      !!this.state.description &&
      !!this.state.title &&
      !!this.state.titleValid &&
      !!this.state.licenseValid &&
      !licenseDuplicated &&
      !!dateValid &&
      !!this.state.postCode &&
      !!this.state.street &&
      !!this.state.prefecture &&
      !!this.state.city &&
      !!this.state.block &&
      this.state.postCode.length >= 7 &&
      isInterval
    ) {
      this.setState({ allValid: true, licenseDuplicated, dateValid });
    } else {
      this.setState({ allValid: false, licenseDuplicated, dateValid });
    }
  };

  _licenseDuplicatedCheck = () => {
    let licenseDuplicated = false;
    const array = [];
    for (let i = 0; i < this.state.licenseFormSize; i++) {
      array.push(this.state[`license${i + 1}`]);
    }

    const duplicated = array.filter(function (x, i, self) {
      return self.indexOf(x) !== self.lastIndexOf(x);
    });

    if (duplicated.length > 0) {
      licenseDuplicated = true;
    }

    return licenseDuplicated;
  };

  _dateValidation = () => {
    const startDate = new DateJp(
      this.state.start_year,
      this.state.start_month,
      this.state.start_date,
      this.state.start_hours,
      this.state.start_minutes
    );
    const endDate = new DateJp(
      this.state.end_year,
      this.state.end_month,
      this.state.end_date,
      this.state.end_hours,
      this.state.end_minutes
    );

    if (startDate < endDate) {
      return true;
    }
    return false;
  };

  _setValue = e => {
    const re = /^[0-9\b]+$/;
    if (e.target.name === 'reward') {
      let rewardTextValue = `${e.target.value}00`;
      if (e.target.value === '') {
        rewardTextValue = '';
      }
      this.setState({ [e.target.name]: e.target.value, rewardText: rewardTextValue }, () => {
        this._checkAllEnter();
      });
    } else if (e.target.name === 'title') {
      let titleValid = true;
      let limit = e.target.value.includes('コピー -') ? 20 : 15;
      if (e.target.value.length > limit) {
        titleValid = false;
      }
      this.setState({ [e.target.name]: e.target.value, titleValid }, () => {
        this._checkAllEnter();
      });
    } else if (e.target.name.match('license') !== null) {
      let licenseValid = true;
      let canAddLicenseForm = true;
      if (e.target.value) {
        for (let i = 0; i < this.state.licenseFormSize; i++) {
          if (i === 0) {
            continue;
          }

          if (!this.state[`license${i + 1}`]) {
            licenseValid = true;
            canAddLicenseForm = true;
          }
        }
      } else {
        // licenseValid = false
        canAddLicenseForm = false;
      }

      this.setState({ [e.target.name]: e.target.value, licenseValid, canAddLicenseForm }, () => {
        this._checkAllEnter();
      });
    } else if (e.target.name === 'postCode') {
      this.parsePostalCode(e);
      this.setState({ [e.target.name]: e.target.value }, () => {
        this._checkAllEnter();
      });
    } else if (e.target.name !== 'postCode') {
      console.log('TCL: e.target.name', e.target.name, e.target.value);
      var isCat = false;
      if (e.target.name == 'taskCategoryName') {
        isCat = true;
      }
      this.setState({ [e.target.name]: e.target.value }, () => {
        if (isCat) {
          this._generateBase64();
        }
        this._checkAllEnter();
      });
    }
  };

  _renderYears = () => {
    return this.state.years.map(year => {
      return (
        <option key={year.key} value={year.value}>
          {year.label}
        </option>
      );
    });
  };

  _renderMonths = () => {
    return this.state.months.map(month => {
      return (
        <option key={month.key} value={month.value}>
          {month.label}
        </option>
      );
    });
  };

  _renderDays = () => {
    return this.state.days.map(day => {
      return (
        <option key={day.key} value={day.value}>
          {day.label}
        </option>
      );
    });
  };

  _renderHours = () => {
    return this.state.hours.map(hour => {
      return (
        <option key={hour.key} value={hour.value}>
          {hour.label}
        </option>
      );
    });
  };

  _renderMinutes = () => {
    return this.state.minutes.map(minute => {
      return (
        <option key={minute.key} value={minute.value}>
          {minute.label}
        </option>
      );
    });
  };

  _renderTaskCategoriesOptions = () => {
    return this.props.Task.categories.map(cat => {
      return (
        <option value={cat.categoryName} key={cat.categoryId}>
          {cat.categoryName}
        </option>
      );
    });
  };

  _renderLicensesOptions = () => {
    const { licenses } = this.props.Task;
    return licenses.map(item => {
      return (
        <option value={item.key} key={item.key}>
          {item.value}
        </option>
      );
    });
  };

  _onClickAddSelect = async () => {
    let licenseValid = true;
    let canAddLicenseForm = true;
    let { licenseFormSize } = this.state;

    if (this.state.licenseValid) {
      licenseFormSize++;
    }

    for (let i = 0; i < licenseFormSize; i++) {
      if (!this.state[`license${i + 1}`]) {
        console.log('TCL: _onClickAddSelect -> license${i + 1}', this.state);
        if (this.state[`license${i + 1}`] == undefined) {
          licenseValid = false;
          break;
        }
        licenseValid = true;
        canAddLicenseForm = true;
      }
    }
    console.log('TCL: licenseFormSize', licenseFormSize, canAddLicenseForm, licenseValid);
    this.setState({ licenseFormSize, canAddLicenseForm, licenseValid }, () => {
      this._checkAllEnter();
    });
  };

  _onClickRemoveSelect = () => {
    let licenseValid = true;
    let canAddLicenseForm = true;
    let { licenseFormSize } = this.state;
    // if (!!this.state.canAddLicenseForm && !!this.state.licenseValid) {
    //   licenseFormSize--
    // }

    licenseFormSize--;

    // console.log('Remove', licenseFormSize, this.state)

    for (let i = 0; i < licenseFormSize; i++) {
      if (!this.state[`license${i + 1}`]) {
        licenseValid = false;
        canAddLicenseForm = true;
      }
    }

    this.setState({ licenseFormSize, canAddLicenseForm, licenseValid }, () => {
      this._checkAllEnter();
    });
  };

  _renderLicensesSelect = () => {
    console.log(
      'TCL: _renderLicensesSelect -> licenseFormSize',
      this.state.licenseFormSize,
      this.state.canAddLicenseForm
    );
    return [...Array(this.state.licenseFormSize)].map((_, i) => {
      return (
        <div className="">
          <select
            className="form-select mb-2"
            name={`license${i + 1}`}
            id=""
            onChange={this._setValue}
            value={this.state[`license${i + 1}`]}
          >
            <option value={0} key={0}>
              資格不要
            </option>
            {this._renderLicensesOptions(i)}
          </select>
          {(() => {
            console.log(
              'TCL: _renderLicensesSelect -> this.state.licenseFormSize',
              this.state.licenseFormSize > 1 && this.state.licenseFormSize === i + 1
            );
            if (this.state.licenseFormSize > 1 && this.state.licenseFormSize === i + 1) {
              return (
                <p
                  className="mt-3 pl-5 task-add-license-btn"
                  onClick={this._onClickRemoveSelect}
                  style={{}}
                >
                  {' '}
                  - 必要な資格を削除する
                </p>
              );
            }
          })()}
          {(() => {
            if (this.state.licenseFormSize === i + 1) {
              return (
                <p
                  className={`mt-3 pl-5 task-add-license-btn ${
                    this.state.canAddLicenseForm ? '' : 'hidden'
                    }`}
                  onClick={this._onClickAddSelect}
                  style={{}}
                >
                  {' '}
                  + さらに資格を追加する
                </p>
              );
            }
          })()}
        </div>
      );
    });
  };

  _checkForImageAvailability = () => {
    var hasImage = '';
    const { taskCategoryName } = this.state;
    if (this.state.images) {
      hasImage = this.state.images;
    } else if (this.state.taskCategoryName) {
      switch (taskCategoryName) {
        case '介護':
          hasImage = caregiver;
          break;
        case '看護':
          hasImage = nurse;
          break;
        case '保育':
          hasImage = childcare;
          break;
        case '清掃':
          hasImage = cleaning;
          break;
        case '事務・経理':
          hasImage = accounting;
          break;
        case '送迎':
          hasImage = pickup;
          break;
        case 'レクリエーション':
          hasImage = recreation;
          break;
        case 'リハビリ・サポート':
          hasImage = rehabilitation;
          break;
        case '受付':
          hasImage = reception;
          break;
        case '調理':
          hasImage = cook;
          break;
        case '配膳':
          hasImage = serving;
          break;
        case '教育':
          hasImage = education;
          break;
      }
    } else {
      hasImage = '';
    }
    return hasImage;
  };

  _checkIfUrl = () => {
    if (this.state.images) {
      return true;
    } else if (this.state.taskCategoryName) {
      return false;
    } else {
      return true;
    }
  };

  _renderPreviewImage = () => {
    const hasImage = this._checkForImageAvailability();
    const ifUrl = this._checkIfUrl();
    return (
      <div className="col-12 image-wrap mt-3 p-2">
        {/* <img alt='画像' className={hasImage ? 'img-fluid' : 'img-fluid hidden'} ref="image" src={this.state.images} /> */}
        <div
          ref="image"
          className={
            hasImage ? 'img-fluid task-preview-image' : 'img-fluid task-preview-image hidden'
          }
          style={{ backgroundImage: ifUrl ? `url(${this.state.images})` : 'url(' + hasImage + ')' }}
        />
        <span className={hasImage ? 'hidden' : ''}>
          ここに画像が表示されます。
          <br />
          （画像は縦横比 3:4 に切り取られます。）
        </span>
      </div>
    );
  };

  _errorClass(error) {
    if (error !== undefined) {
      return error.length === 0 ? '' : 'has-error';
    }
  }

  parsePostalCode = async e => {
    this.setState({ prefecture: '', city: '', block: '', allValid: false });
    if (e.target.value.length >= 7) {
      await addressFromPostalCode(e.target.value).then(address => {
        console.log('TCL: address', address);
        this.setState(
          {
            prefecture: address.prefecture ? address.prefecture : '',
            city: address.city ? address.city : '',
            block: address.area ? address.area : ''
          },
          () => {
            this._checkAllEnter();
          }
        );
      });
    }
  };

  _renderTemplate = items => {
    return items.map(item => {
      return (
        <option key={item.templateId} value={item.templateId}>
          {item.templateName}
        </option>
      );
    });
  };

  _renderTemplateData = items => {
    if (this.state.templateId.length > 0) {
      const TemplateId = this.state.templateId;
      const item = items.filter(function (item) {
        return item.templateId == TemplateId;
      });
      return (
        <div>
          <div
            className="textarea-border"
            dangerouslySetInnerHTML={{ __html: item[0].templateMessage }}
          />

          <div className="form-group position-relative col-12">
            <label>持ち物</label>
          </div>
          <div className="belongings_div">
            {item[0].bringList.map(item => {
              return <li>{item} </li>;
            })}
          </div>
          <div className="form-group position-relative col-12">
            <label>条件・注意事項</label>
          </div>
          <div className="belongings_div">
            {item[0].precautionList.map(item => {
              return <li>{item} </li>;
            })}
          </div>
        </div>
      );
    }
  };

  selectWeekDays = item => {
    const { weekDays } = this.state;
    let index = weekDays.findIndex(element => element.dayOfTheWeek === item.target.value);
    weekDays[index].checked = item.target.checked;
    weekDays.splice(index, 1, weekDays[index]);
    console.log('TCL: selectWeekDays item', weekDays);
    this._checkAllEnter();
  };

  onRadioSelect = e => {
    console.log('TCL: e', e);
    switch (e) {
      case '1':
        this.setState({ isRegular: true }, () => {
          this._checkAllEnter();
        });
        break;
      case '2':
        this.setState({ isRegular: false }, () => {
          this._checkAllEnter();
        });
        break;
      default:
        break;
    }
  };

  _renderTaskForm = () => {
    console.log('TCL: _renderTaskForm -> this.state.taskCategoryId', this.state.taskCategoryName);
    const items = this.props.Template.TemplateItems;
    return (
      <div className={this.state.preview ? 'hidden' : ''}>
        <div className="form-group">
          <label htmlFor="">タスク名</label>
          {(() => {
            if (!this.state.titleValid) {
              return (
                <div className="alert alert-danger" role="alert">
                  タスク名は<strong>15文字以内</strong>で設定してください。
                </div>
              );
            }
          })()}
          <input
            type="text"
            className={`form-control${this.state.titleValid ? '' : ' alert-form'}`}
            id=""
            placeholder="入力してください"
            name="title"
            defaultValue={this.state.title}
            onChange={this._setValue}
          />
        </div>
        <div className="row">
          <div className="form-group position-relative col-6">
            <div>
              <label htmlFor="exampleInputPassword1">業務内容</label>
              <br />
              <select
                className="form-select"
                name="taskCategoryName"
                id="taskCategoryName"
                onChange={this._setValue}
                value={this.state.taskCategoryName}
              >
                <option value="" key="0" />
                {this._renderTaskCategoriesOptions()}
              </select>
            </div>
            <div className="mt-4 task-submission">
              <label>タスク投稿方法</label>
              <div className="task-submission-inner">
                <RadioGroup onChange={this.onRadioSelect} horizontal>
                  <RadioButton
                    value="1"
                    pointColor={'#ea5d8c'}
                    rootColor={'#000000'}
                    iconSize={20}
                    iconInnerSize={10}
                    checked={this.state.isRegular}
                  >
                    <span>単発</span>
                    {'   '}
                    <Tooltip content="tooltip">
                      <i className="fas fa-info-circle" />
                    </Tooltip>
                  </RadioButton>
                  <RadioButton
                    value="2"
                    pointColor={'#ea5d8c'}
                    rootColor={'#000000'}
                    iconSize={20}
                    iconInnerSize={10}
                  >
                    <span>定期</span>
                    {'   '}
                    <Tooltip content="tooltip">
                      <i className="fas fa-info-circle" />
                    </Tooltip>
                  </RadioButton>
                </RadioGroup>
              </div>
            </div>
            {!this.state.isRegular && (
              <div className="mt-4">
                <label>投稿スケジュール</label>
                {'   '}
                <Tooltip content="tooltip">
                  <i className="fas fa-info-circle" />
                </Tooltip>
                <div className="multiple-block">
                  {generateWeekDay(this.state.weekDays, this.selectWeekDays)}
                </div>
              </div>
            )}
            <div className="mt-4">
              {(() => {
                if (!this.state.dateValid) {
                  return (
                    <div className="alert alert-danger" role="alert">
                      <strong>終了時刻</strong>は、<strong>開始時刻</strong>
                      より後の時刻に設定してください。
                    </div>
                  );
                }
              })()}
              <div>
                <label htmlFor="exampleInputPassword1">開始時刻</label>
                {'   '}
                <Tooltip content="tooltip">
                  <i className="fas fa-info-circle" />
                </Tooltip>
              </div>
              <select
                className="form-select"
                name="start_year"
                id=""
                onChange={this._setValue}
                defaultValue={this.state.start_year}
              >
                {this._renderYears()}
              </select>
              <select
                className="form-select"
                name="start_month"
                id=""
                onChange={this._setValue}
                defaultValue={this.state.start_month}
              >
                {this._renderMonths()}
              </select>
              <select
                className="form-select"
                name="start_date"
                id=""
                onChange={this._setValue}
                defaultValue={this.state.start_date}
              >
                {this._renderDays()}
              </select>
              <select
                className="form-select"
                name="start_hours"
                id=""
                onChange={this._setValue}
                defaultValue={this.state.start_hours}
              >
                {this._renderHours()}
              </select>
              <select
                className="form-select"
                name="start_minutes"
                id=""
                onChange={this._setValue}
                defaultValue={this.state.start_minutes}
              >
                {this._renderMinutes()}
              </select>
            </div>

            <div className="mt-4">
              <div>
                <label htmlFor="exampleInputPassword1">終了時刻</label>
                {'   '}
                <Tooltip content="tooltip">
                  <i className="fas fa-info-circle" />
                </Tooltip>
              </div>
              <select
                className="form-select"
                name="end_year"
                id=""
                onChange={this._setValue}
                defaultValue={this.state.end_year}
              >
                {this._renderYears()}
              </select>
              <select
                className="form-select"
                name="end_month"
                id=""
                onChange={this._setValue}
                defaultValue={this.state.end_month}
              >
                {this._renderMonths()}
              </select>
              <select
                className="form-select"
                name="end_date"
                id=""
                onChange={this._setValue}
                defaultValue={this.state.end_date}
              >
                {this._renderDays()}
              </select>
              <select
                className="form-select"
                name="end_hours"
                id=""
                onChange={this._setValue}
                defaultValue={this.state.end_hours}
              >
                {this._renderHours()}
              </select>
              <select
                className="form-select"
                name="end_minutes"
                id=""
                onChange={this._setValue}
                defaultValue={this.state.end_minutes}
              >
                {this._renderMinutes()}
              </select>
            </div>
            <div className="form-row mt-4">
              <div className="col-sm-12">
                <label htmlFor="">
                  タスク実施住所
                  <label className="red-text">
                    *タスクが実施される都道府県と市区町村が応募者の登録住所に紐づいて表示されます
                  </label>
                </label>
              </div>
              <div className="form-group col-sm-3">
                <label htmlFor="postCode">郵便番号</label>
                <input
                  type="text"
                  name="postCode"
                  className={`form-control`}
                  id="postCode"
                  placeholder="未入力"
                  maxLength={7}
                  value={this.state.postCode}
                  onChange={this._setValue}
                  onBlur={this.parsePostalCode}
                />
              </div>
              <div class="col-sm-12"></div>
              <div className="form-group col-sm-2">
                <label htmlFor="prefecture">都道府県</label>
                <input
                  type="text"
                  className="form-control"
                  id="prefecture"
                  name="prefecture"
                  readOnly
                  value={this.state.prefecture}
                />
              </div>
              <div className="form-group col-sm-2">
                <label htmlFor="city">市区町村</label>
                <input
                  type="text"
                  className="form-control"
                  id="city"
                  readOnly
                  value={this.state.city}
                />
              </div>
              <div className="form-group col-sm-3">
                <label htmlFor="block">地名</label>
                <input
                  type="text"
                  className="form-control"
                  id="block"
                  name="block"
                  readOnly
                  value={this.state.block}
                />
              </div>
              <div className="form-group col-sm-5">
                <label htmlFor="street">番地</label>
                <input
                  type="text"
                  className={`form-control`}
                  id="street"
                  name="street"
                  name="street"
                  placeholder="通り"
                  value={this.state.street}
                  onChange={this._setValue}
                />
              </div>
            </div>
            <div className="mt-4">
              <label htmlFor="exampleInputPassword1">必須資格</label>
              <br />
              {(() => {
                if (this.state.licenseDuplicated) {
                  return (
                    <div className="alert alert-danger" role="alert">
                      必要な資格が重複しています。
                    </div>
                  );
                }
              })()}
              {this._renderLicensesSelect()}
            </div>
          </div>

          <div className="form-group position-relative col-6">
            <label htmlFor="exampleInputPassword1">アイキャッチ画像</label>
            <div className="text-center">
              <div className="form-group position-relative row-1" style={{ textAlign: 'left' }}>
                <input type="file" accept="image/*" onChange={this.onImageSelected} />
                {this._renderPreviewImage()}
              </div>
            </div>
          </div>

          <div className="form-group col-12">
            <label htmlFor="exampleInputEmail1" style={{ width: '100%' }}>
              報酬(交通費を含むタスクの報酬の合計を入力してください)
            </label>
            <input
              type="number"
              min="1"
              className="form-control"
              defaultValue={this.state.reward}
              style={{
                width: '300px',
                display: 'inline-block',
                marginRight: '10px'
              }}
              onChange={this._setValue}
              name="reward"
            />
            <span>00円</span>

            <div className="task-line-form-wrap">
              <input
                type="text"
                className="form-control task-line-form"
                style={{ width: '300px' }}
                defaultValue={String(this.state.rewardText).replace(
                  /(\d)(?=(\d\d\d)+(?!\d))/g,
                  '$1,'
                )}
                name="rewardText"
                readOnly
              />
            </div>
          </div>

          <div className="form-group position-relative col-12">
            <label htmlFor="exampleInputPassword1">タスクの説明文</label>
            <textarea
              type="password"
              className="form-control"
              style={{ height: '200px' }}
              name="description"
              onChange={this._setValue}
              defaultValue={this.state.description}
            />
          </div>

          <div className="form-group position-relative col-12">
            <label>承認時に送る注意事項</label>
            <br />
            <select
              className="form-select"
              name="templateId"
              id=""
              onChange={this._setValue}
              defaultValue={this.state.start_date}
            >
              <option value="" key="0" />
              {this._renderTemplate(items)}
            </select>
          </div>
          {this.state.templateId.length == 0 && (
            <div className="col-sm-12">
              <label htmlFor="">
                <label className="red-text">
                  *タスクを承認したタスクルーに送信する注意事項テンプレートを1つ選択してください
                </label>
              </label>
            </div>
          )}
          {this._renderTemplateData(items)}

          <div className="col-12 mt-4 pb-5" style={{ textAlign: 'right' }}>
            <button
              disabled={!this.state.allValid}
              className="btn btn-primary"
              onClick={this.registerPreview}
            >
              新規タスクの登録
            </button>
          </div>
        </div>
      </div>
    );
  };

  _renderPreview = () => {
    return (
      <div className={`pb-3${this.state.preview ? '' : ' hidden'}`}>
        <h3>プレビュー/確認</h3>
        {this.previewTask()}

        <p className="preview-notice">
          資格設定は、保有者にのみ見られるようになるため、プレビューには表示されません。
        </p>
        <p className="preview-licenses">
          資格：
          {(() => {
            const task = this.generateTask();
            if (task && task.licenseDetail) {
              return task.licenseDetail.map((license, i) => {
                const last = i + 1 === task.licenseDetail.length;
                let text;
                if (last) {
                  text = license.value;
                } else {
                  text = `${license.value}/`;
                }
                // eslint-disable-next-line react/no-array-index-key
                return <span key={i}>{text}</span>;
              });
            }
            return <span>-</span>;
          })()}
        </p>
        <button className="btn btn-cancel" onClick={this.previewClose}>
          編集に戻る
        </button>
        <button className="btn btn-primary ml-5" onClick={this.registerTaskAction}>
          新規タスクの確定
        </button>
      </div>
    );
  };

  previewTask = () => {
    const task = this.generateTask();
    const taskCategory = this.props.Task.categories.find(
      cat => cat.categoryName === this.state.taskCategoryName
    );
    const categoryName = taskCategory === undefined ? '' : taskCategory.categoryName;
    // console.log('ぷれびゅー', task)
    // console.log('かてごり', taskCategory, this.state.taskCategoryId)
    const hasImage = this._checkForImageAvailability();
    const ifUrl = this._checkIfUrl();
    return (
      <div className="preview-task-card">
        <div
          className="task-image"
          style={{ backgroundImage: ifUrl ? `url(${this.state.images})` : 'url(' + hasImage + ')' }}
        />
        <div className="task-body">
          <p className="task-date">
            {task.startDate} {task.startTime} - {task.endTime}
          </p>
          <p>
            <span className="task-cat-icon">{categoryName}</span>
          </p>
          <h2 className="task-title">
            {task.title}
            <span className="task-fee-text">
              報酬
              <span className="ml-3">
                {String(task.fee).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}円
              </span>
            </span>
          </h2>
          <p className="task-enterprise-name">{this.currentUser.enterpriseName}</p>
          <p className="task-line">
            <MdLocationOn style={{ color: '#EA5D8C' }} className="place-icon" />
            {this.state.postCode} {this.state.prefecture} {this.state.city} {this.state.street}
          </p>
          <p className="mt-4">{task.description}</p>
        </div>
      </div>
    );
  };

  render = () => {
    const confirmTask = this.generateTask();
    const allEntryCount = 1;
    // console.log('categoryID', this.state.taskCategoryId);
    return (
      <Template>
        <Modal
          isOpen={this.state.modalOpen}
          closeModal={() => this.toTopPage()}
          headerTitle="新規タスクを登録しました。"
          okClickHandler={null}
        >
          <TaskCardForDetail task={confirmTask} allEntryCount={allEntryCount} />
          <div className="task-created-button">
            <button onClick={this.toTopPage} className="btn btn-primary">
              タスク一覧へ戻る
            </button>
          </div>
        </Modal>
        <div className="task-register-main">
          <h2>新規タスクの登録</h2>
          <h3 className="sub-title">
            新しいタスクを作成します。表示項目は全て入力が必要です。
            <br />
            入力が完了しましたらページ右下の「新規タスクの登録」ボタンを押下して、タスクを公開してください。
            <br />
            公開後はタスケルユーザーが閲覧・応募することができます。
          </h3>
          {/* {(() => {
            if (this.state.preview) {
              return this._renderPreview()
            } else {
              return this._renderTaskForm()
            }
          })()} */}
          {this._renderPreview()}
          {this._renderTaskForm()}
          {/* {this._renderTaskForm()} */}
        </div>
      </Template>
    );
  };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      resetRegisterTask,
      getCategories,
      getLicensesInTask,
      getTaskDetail,
      getTemplateData,
      registerTask
    },
    dispatch
  );

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);
